<template>
  <div class="container">
    <div class="intro">
      <div class="card-panel center-align flow-text">
        <img class="logo-splash" src="../assets/logo-splash.png">
        <p class="app-title">Anonymously track your bullion's net worth.
          <!-- <br>This is cumbersome to do manually as the Gold and Silver may be bought overtime at varying prices. -->
        </p>

        <router-link
          class="waves-effect waves-light btn-large amber darken-4"
          :to="{ name: 'AddAssets', params: { user_id } }"
        >Start Stacking</router-link>

        <router-link
          class="waves-effect waves-light btn-large red darken-4"
          :to="{ name: 'ViewAssets', params: { user_id: exampleUserID } }"
        >View Example</router-link>

        <p
          class="app-stack-desc"
        >This app demonstrates how to use Vue.js and Firebase to build a reactive single page application. We use the Async/Await Promise constructor to fetch a third party API for live bullion prices. The Materialize CSS ensures that the overall design is responsive.</p>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from "@/helpers/helpers";

export default {
  name: "Intro",
  data() {
    return {
      exampleUserID: "ZgU6g0zy",
      user_id: null
    };
  },
  methods: {
    updateID() {
      this.user_id = this.$route.params.user_id;
    }
  },
  created() {
    this.user_id = helpers.randomString(8);
  },
  updated() {
    if (this.$route.params.user_id) {
      // this.user_id = this.$route.params.user_id;
      updateID();
    }
  },
  watch: {
    $route: "updateID"
  }
};
</script>

<style scoped>
.container .intro {
  margin-top: 50px;
}
.app-stack-desc {
  margin-top: 40px;
  color: darkgrey;
}
.container .btn-large {
  margin-top: 5px;
}
.app-title {
  margin-top: 10px;
}
.intro .logo-splash {
  max-width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/Intro.vue